{
  "error_occurred": "Tapahtui virhe. Yritä uudelleen.",
  "placeholders": {
    "enter_email": "Syötä sähköpostiosoite",
    "enter_password": "Syötä salasana"
  },
  "fields": {
    "first_name": "Etunimi",
    "last_name": "Sukunimi",
    "email_address": "Sähköposti",
    "password": "Salasana",
    "confirm_password": "Vahvista salasana",
    "email": "Sähköposti",
    "course_name": "Kentän nimi",
    "location": "Sijainti",
    "latitude": "Leveysaste",
    "longitude": "Pituusaste",
    "street_address": "Katuosoite",
    "city": "Kaupunki",
    "country": "Maa",
    "gender": "Sukupuoli",
    "series": "Sarja",
    "player": "Pelaaja",
    "players": "Pelaajat",
    "team": "Joukkue",
    "flight": "Lähtö",
    "tee": "Tii",
    "tee_color": "Tiin väri",
    "tees": "Tiit",
    "course": "Kenttä",
    "date": "Päivämäärä",
    "slope": "Slope",
    "club": "Seura",
    "status": "Tila",
    "start_time": "Lähtöaika",
    "hole": "Reikä",
    "total": "Yht.",
    "member_number": "Jäsennumero",
    "birth_date": "Syntymäaika"
  },
  "loading": "Ladataan...",
  "optional": "Valinnainen",
  "actions": {
    "cancel": "Peruuta",
    "edit": "Muokkaa",
    "delete": "Poista",
    "deleted": "Poistettu",
    "delete_selected": "Poista valitut",
    "activate_selected": "Aktivoi valitut",
    "deactivate_selected": "Poista käytöstä valitut",
    "create": "Luo",
    "update": "Päivitä",
    "select": "Valitse",
    "select_all": "Valitse kaikki",
    "clear": "Tyhjennä",
    "activate": "Aktivoi",
    "deactivate": "Deaktivoi",
    "previous": "Edellinen",
    "remove": "Poista",
    "next": "Seuraava",
    "add": "Lisää",
    "more": "Lisää toimintoja",
    "save": "Tallenna",
    "saving": "Tallennetaan...",
    "close": "Sulje",
    "continue": "Jatka",
    "continue_to_payment": "Jatka maksuun",
    "pay_later": "Maksan myöhemmin",
    "submit": "Lähetä",
    "submitting": "Lähetetään...",
    "redirecting_to_payment": "Siirrytään maksuun...",
    "pay_participation": "Maksa osallistuminen",
    "confirm": "Vahvista",
    "show": "Näytä",
    "hide": "Piilota",
    "undo": "Kumoa",
    "export_pdf": "Lataa PDF",
    "loading": "Ladataan...",
    "load_more": "Näytä lisää",
    "like": "Tykkää",
    "comment": "Kommentoi",
    "copy": "Kopioi",
    "deselect_all": "Poista valinnat"
  },
  "batch_actions": "Toiminnot",
  "batch_actions_disabled": "Valitse ensin kohteet",
  "errors": {
    "generic": "Tapahtui virhe. Yritä uudelleen.",
    "export_failed": "PDF:n luominen epäonnistui",
    "accessDenied": "Pääsy evätty",
    "managerAccessRequired": "Tämän sivun katselu vaatii manageritason käyttöoikeudet.",
    "failed_to_load": "Lataaminen epäonnistui",
    "failed_to_save": "Tallennus epäonnistui",
    "Failed to update round": "Kierroksen päivittäminen epäonnistui",
    "no_courses_available": "Kenttiä ei ole saatavilla",
    "Irish Rumble requires all series to allow exactly 4 players per team.": "Irish Rumble vaatii kaikissa sarjoissa tarkalleen 4 pelaajan joukkueet",
    "Irish Rumble requires exactly 4 players per team": "Irish Rumble vaatii 4 pelaajaa joukkueessa",
    "Irish Rumble requires at least one series to be configured before creating a round.": "Irish Rumble vaatii vähintään yhden sarjan ennen kierroksen luomista",
    "Minimum team size must be at least": "Vähimmäisjoukkuekoon on oltava vähintään",
    "Maximum team size must be at least": "Enimmäisjoukkuekoon on oltava vähintään",
    "Minimum team size must be less than or equal to maximum team size": "Vähimmäisjoukkuekoon on oltava pienempi tai yhtä suuri kuin enimmäisjoukkuekoko",
    "Cannot set team size to {min}-{max} because this competition has Irish Rumble rounds which require exactly 4 players per team": "Joukkuekokoa ei voi asettaa välille {{min}}-{{max}}, koska kilpailussa on Irish Rumble -kierroksia, jotka vaativat 4 pelaajaa joukkueessa",
    "Cannot link to ranking series without a default point system. Please configure a default point system for": "Rankingsarjaan ei voi linkittää ilman oletuspistejärjestelmää. Aseta oletuspistejärjestelmä seuraavalle"
  },
  "status": {
    "active": "Aktiivinen",
    "inactive": "Passiivinen",
    "verified": "Vahvistettu",
    "unverified": "Vahvistamaton",
    "completed": "Valmis",
    "loading": "Ladataan...",
    "processing": "Käsitellään...",
    "creating": "Luodaan...",
    "adding": "Lisätään...",
    "in_progress": "Käynnissä",
    "playing": "Pelaa",
    "please_wait": "Odota hetki...",
    "changes_saved": "Muutokset tallennettu",
    "logging_out": "Kirjaudutaan ulos..."
  },
  "labels": {
    "status": "Tila",
    "created": "Luotu",
    "actions": "Toiminnot",
    "required": "*",
    "n_a": "Ei saatavilla",
    "today": "Tänään",
    "total": "Yhteensä",
    "error": "Virhe",
    "not_set": "Ei asetettu",
    "back": "Takaisin",
    "new": "Uusi",
    "go_back": "Palaa takaisin"
  },
  "gender": {
    "not_specified": "Ei määritelty",
    "male": "Mies",
    "female": "Nainen",
    "other": "Muu"
  },
  "gender_plural": {
    "not_specified": "Ei määritelty",
    "male": "Miehet",
    "female": "Naiset",
    "other": "Muut"
  },
  "navigation": {
    "dashboard": "Etusivu",
    "logout": "Kirjaudu ulos",
    "roles": {
      "PLAYER": {
        "items": {
          "dashboard": "Etusivu",
          "events": "Tapahtumat",
          "friends": "Kaverit",
          "competitions": "Tapahtumat",
          "rankings": "Ranking",
          "ranking": "Ranking",
          "calendar": "Tapahtumakalenteri",
          "series": "Rankingsarjat",
          "stats": "Tilastot",
          "profile": "Profiili"
        }
      },
      "MANAGER": {
        "items": {
          "dashboard": "Etusivu",
          "events": "Tapahtumat",
          "competitions": "Kilpailut",
          "rankings": "Ranking",
          "ranking": "Ranking",
          "administration": "Hallinta",
          "reports": "Raportit",
          "settings": "Asetukset",
          "calendar": "Kalenteri",
          "series": "Rankingsarjat",
          "pointSystems": "Pistejärjestelmät",
          "analyticsAdmin": "Analytiikka",
          "courseStats": "Kentän tilastot",
          "payments": "Maksuraportti",
          "scheduleTemplates": "Aikataulumallit",
          "scorecardTemplates": "Tuloskorttipohjat",
          "templates": "Pohjat",
          "createEvent": "Luo tapahtuma",
          "categories": "Kategoriat",
          "addOns": "Lisäpalvelut",
          "polls": "Kyselyt"
        }
      },
      "SUPERUSER": {
        "items": {
          "dashboard": "Etusivu",
          "competitions": "Kilpailut",
          "rankings": "Ranking",
          "ranking": "Ranking",
          "administration": "Hallinta",
          "reports": "Raportit",
          "settings": "Asetukset",
          "tenants": "Seurat",
          "clubs": "Seurat",
          "calendar": "Kalenteri",
          "users": "Käyttäjät",
          "series": "Rankingsarjat",
          "pointSystems": "Pistejärjestelmät",
          "analyticsAdmin": "Analytiikka",
          "courseStats": "Kentän tilastot",
          "payments": "Maksuraportti",
          "scheduleTemplates": "Aikataulumallit",
          "scorecardTemplates": "Tuloskorttipohjat",
          "templates": "Pohjat",
          "handicapRecommendations": "Tasoitussuositukset",
          "emailLog": "Sähköpostit",
          "other": "Muut",
          "super": "Super",
          "createEvent": "Luo tapahtuma",
          "categories": "Kategoriat",
          "addOns": "Lisäpalvelut",
          "polls": "Kyselyt"
        }
      }
    },
    "megamenu": {
      "dashboard": "Etusivu",
      "events": "Tapahtumat",
      "competitions": "Tapahtumat",
      "ranking": "Ranking",
      "pointSystems": "Pistejärjestelmät",
      "series": "Rankingsarjat",
      "friends": "Kaverit",
      "stats": "Tilastot",
      "profile": "Profiili",
      "administration": "Hallinta",
      "settings": "Asetukset",
      "templates": "Pohjat",
      "calendar": "Tapahtumakalenteri",
      "reports": "Raportit",
      "other": "Muut",
      "super": "Super",
      "analyticsAdmin": "Analytiikka",
      "courseStats": "Kentän tilastot",
      "payments": "Maksuraportti",
      "scheduleTemplates": "Aikataulumallit",
      "scorecardTemplates": "Tuloskorttipohjat",
      "users": "Käyttäjät",
      "handicapRecommendations": "Tasoitussuositukset",
      "emailLog": "Sähköpostit",
      "clubs": "Seurat",
      "tenants": "Asiakkaat",
      "createEvent": "Luo tapahtuma",
      "categories": "Kategoriat",
      "addOns": "Lisäpalvelut",
      "polls": "Kyselyt"
    },
    "actions": {
      "open_menu": "Avaa valikko",
      "close_menu": "Sulje valikko",
      "logout": "Kirjaudu ulos"
    },
    "menu": "Valikko",
    "courseAnalytics": "Tilastot"
  },
  "admin": {
    "user_management": "Käyttäjahallinta",
    "manage_users_desc": "Hallinnoi käyttäjätilejä ja oikeuksia",
    "all_users": "Kaikki käyttäjät",
    "failed_to_load_users": "Käyttäjien lataaminen epaonnistui"
  },
  "validation": {
    "form_has_errors": "Lomakkeessa on virheitä. Korjaa virheet ennen tallennusta.",
    "email_required": "Sähköpostiosoite on pakollinen tieto",
    "email_invalid": "Virheellinen sähköpostiosoite",
    "password_required": "Salasana on pakollinen tieto",
    "password_min_length": "Salasanan on oltava vähintään 8 merkkiä",
    "password_needs_uppercase": "Salasanassa on oltava vähintään yksi iso kirjain",
    "password_needs_lowercase": "Salasanassa on oltava vähintään yksi pieni kirjain",
    "password_needs_number": "Salasanassa on oltava vähintään yksi numero",
    "password_needs_special": "Salasanassa on oltava vähintään yksi erikoismerkki",
    "confirm_password_required": "Vahvista salasana",
    "passwords_dont_match": "Salasanat eivät täsmää",
    "course_name_required": "Kentän nimi on pakollinen",
    "latitude_required": "Leveysaste on pakollinen",
    "longitude_required": "Pituusaste on pakollinen",
    "holes_must_be_between_1_18": "Reikien määrän on oltava välillä 1-18",
    "could_not_get_location": "Sijaintia ei voitu hakea. Syötä koordinaatit käsin.",
    "geolocation_not_supported": "Selaimesi ei tue sijaintihakua",
    "validation_error": "Tarkista tiedot. CR:n tulee olla 40-90 ja slopen 55-155 välillä.",
    "server_error_check_data": "Palvelinvirhe. Tarkista etta CR:t ovat 40-90 ja slopet 55-155 välillä."
  },
  "confirm": {
    "delete": {
      "header": "Vahvista poistaminen",
      "body": "Haluatko varmasti poistaa tämän kohteen? Toimintoa ei voi perua."
    },
    "unsaved_changes_title": "Tallentamattomat muutokset",
    "unsaved_changes": "Sinulla on tallentamattomia muutoksia. Haluatko varmasti jatkaa?",
    "save_and_continue": "Tallenna muutokset",
    "continue_without_saving": "Jatka tallentamatta"
  },
  "users": {
    "search_placeholder": "Hae nimellä tai sähköpostilla...",
    "search_failed": "Käyttäjien haku epaonnistui",
    "no_results": "Käyttäjiä ei löytynyt"
  },
  "breadcrumbs": {
    "welcome_back": "Tervetuloa takaisin",
    "user_management": "Käyttäjahallinta",
    "scorecard_management": "Tuloskorttihallinta",
    "scorecard_view": "Tuloskortti",
    "profile": "Profiili",
    "administration": "Hallinta",
    "settings": "Asetukset",
    "competition_calendar": "Tapahtumakalenteri",
    "new_competition": "Uusi tapahtuma",
    "payment_report": "Maksuraportti",
    "reports": "Raportit"
  },
  "administration": {
    "title": "Hallinta",
    "courseAnalytics": {
      "title": "Kentän Tilastot",
      "description": "Analysoi kentan vaikeutta, pistemäärien jakaumia ja reikäkohtaisia tilastoja"
    },
    "timeScheduleTemplates": {
      "title": "Aikataulumallit",
      "description": "Hallinnoi tavoiteaikataulumalleja pelinopeusvaroituksiin ja pelaajien seuraantaa"
    },
    "pointSystems": {
      "title": "Pistejärjestelmät",
      "description": "Hallinnoi ranking-pistejärjestelmiä ja pistejakaumia"
    },
    "handicapRecommendations": {
      "title": "Tasoitussuositukset",
      "description": "Hallinnoi Golfliiton tasoitussuosituksia eri pelityypeille"
    },
    "scorecards": {
      "title": "Tuloskorttipohjat",
      "description": "Hallinnoi Tuloskorttipohjia ja kenttätietoja"
    },
    "tenants": {
      "title": "Seurat",
      "description": "Hallinnoi seuroja ja yhteisöjä"
    },
    "paymentReport": {
      "title": "Maksuraportti",
      "description": "Näytä ja suodata kilpailumaksut",
      "fromDate": "Alkaen",
      "toDate": "Päättyen",
      "status": "Tila",
      "allStatuses": "Kaikki tilat",
      "search": "Hae",
      "date": "Päivämäärä",
      "payer": "Maksaja",
      "type": "Tyyppi",
      "competition": "Kilpailu",
      "statusColumn": "Tila",
      "net": "Netto",
      "vat": "ALV",
      "total": "Yhteensä",
      "noPayments": "Ei maksuja",
      "summaryTotal": "Yhteensä ({{count}} maksua)",
      "exportPdf": "Lataa PDF",
      "pdfColumns": "PDF-sarakkeet",
      "pdfPages": "Sivut",
      "pdfAllPages": "Kaikki sivut ({{count}} riviä)",
      "pdfCurrentPage": "Tämä sivu ({{count}} riviä)",
      "pdfFooterPage": "Sivu {{page}} / {{pages}}",
      "kicker": "Maksuraportti · Tapahtumat",
      "period": "Jakso",
      "club": "Seura",
      "filter": "Suodatin",
      "page": "Sivu",
      "paymentsUnit": "maksua",
      "paymentsSection": "Maksut",
      "rowsMeta": "{{rows}} riviä · sivu {{page}} / {{pages}}",
      "rowsMetaAll": "{{rows}} riviä",
      "pageTotal": "Sivu yhteensä",
      "selectedUnit": "maksua valittu",
      "refundSelected": "Hyvitä valitut",
      "statuses": {
        "created": "Luotu",
        "pending": "Odottaa",
        "completed": "Maksettu",
        "failed": "Epäonnistunut",
        "cancelled": "Peruttu",
        "expired": "Vanhentunut",
        "partially_refunded": "Osittain palautettu",
        "fully_refunded": "Palautettu"
      },
      "types": {
        "competition_fee": "Kilpailumaksu",
        "registration_intent": "Ilmoittautumismaksu"
      },
      "allTenants": "Kaikki seurat",
      "batchActions": "Toiminnot",
      "batchActionsDisabled": "Valitse maksuja ensin",
      "refund": {
        "action": "Hyvitä valitut ({{count}}kpl)",
        "modalTitle": "Vahvista hyvitys",
        "reasonLabel": "Hyvityksen syy",
        "reasonPlaceholder": "Valitse syy",
        "notesLabel": "Lisätietoja",
        "notesPlaceholder": "Vapaaehtoinen lisätieto",
        "notesRequired": "Lisätietoja vaaditaan kun syynä on \"Muu syy\"",
        "warning": "Hyvitys on peruuttamaton toimenpide.",
        "confirmButton": "Hyvitä",
        "successMessage": "{{count}} maksua hyvitetty onnistuneesti",
        "partialSuccessMessage": "{{successCount}} maksua hyvitetty, {{failCount}} epäonnistui",
        "failMessage": "Hyvitys epäonnistui",
        "totalAmount": "Hyvitettävä summa yhteensä",
        "reasons": {
          "CUSTOMER_REQUEST": "Asiakkaan pyyntö",
          "COMPETITION_CANCELLED": "Kilpailu peruutettu",
          "DUPLICATE_PAYMENT": "Tuplamaksu",
          "PARTICIPANT_WITHDRAWN": "Osallistuja vetäytynyt",
          "OVERCHARGE": "Yliveloitus",
          "OTHER": "Muu syy"
        }
      },
      "paytrailDetails": {
        "title": "Paytrail-maksun tiedot",
        "loadError": "Maksun tietojen haku Paytrailista epäonnistui",
        "transactionId": "Tapahtumatunnus",
        "status": "Tila",
        "provider": "Maksutapa",
        "amount": "Summa",
        "stamp": "Yksilöintitunnus",
        "reference": "Viite",
        "createdAt": "Luotu",
        "paidAt": "Maksettu",
        "filingCode": "Arkistointitunnus",
        "cardInfo": "Korttitiedot",
        "href": "Maksusivu"
      }
    },
    "users": {
      "title": "Käyttäjät",
      "description": "Hallinnoi käyttäjiä ja käyttöoikeuksia"
    },
    "emailLog": {
      "title": "Sähköpostit",
      "description": "Listaus lähetetyistä sähköposteista"
    },
    "polls": {
      "title": "Kyselyt",
      "description": "Hallinnoi kentän palautekyselyitä ja tarkastele tuloksia"
    }
  },
  "reports": {
    "title": "Raportit",
    "courseAnalytics": {
      "title": "Kentän Tilastot",
      "description": "Analysoi kentän vaikeutta, pistemäärien jakaumia ja reikäkohtaisia tilastoja"
    },
    "paymentReport": {
      "title": "Maksuraportti",
      "description": "Näytä ja suodata kilpailumaksut"
    }
  },
  "settings": {
    "title": "Asetukset"
  },
  "roles": {
    "display_names": {
      "PLAYER": "Pelaaja",
      "MANAGER": "Manager",
      "CADDIEMASTER": "Caddiemaster",
      "SUPERUSER": "Pääkäyttäjä"
    }
  },
  "update": {
    "title": "Päivitetään uuteen versioon..."
  },
  "rankings": {
    "title": "Rankingsarjat",
    "subtitle": "Hallinnoi rankingsarjoja ja tulostauluja",
    "series_count_one": "{{count}} rankingsarja",
    "series_count_other": "{{count}} rankingsarjaa",
    "no_series": "Ei vielä rankingsarjoja",
    "no_series_for_season": "Ei rankingsarjoja kaudelle {{season}}",
    "create_first": "Luo ensimmäinen ranking",
    "create_ranking_series": "Luo rankingsarja",
    "public_rankings": "Julkinen ranking",
    "edit_ranking_series": "Muokkaa rankingsarjaa",
    "update_ranking_series": "Päivitä rankingsarja",
    "configure_subtitle": "Määritä rankingsarja",
    "failed_to_load": "Rankingien lataaminen epäonnistui",
    "failed_to_load_series": "Rankingsarjan lataaminen epäonnistui",
    "failed_to_save": "Rankingsarjan tallennus epäonnistui",
    "failed_to_delete": "Rankingsarjan poisto epäonnistui",
    "deleted_success": "Rankingsarja poistettu",
    "created_success": "Rankingsarja luotu",
    "updated_success": "Rankingsarja päivitetty",
    "confirm_delete": "Haluatko varmasti poistaa \"{{name}}\"?",
    "delete_series_warning_title": "Poista rankingsarja",
    "delete_series_warning_body": "Tällä rankingsarjalla on {{count}} ranking-tapahtumaa. Poistaminen irrottaa kaikki tapahtumat, tulokset ja pisteet. Tätä ei voi perua.",
    "click_to_edit": "Klikkaa muokataksesi",
    "saving": "Tallennetaan...",
    "no_ranking_series_available": "Ei rankingsarjoja saatavilla",
    "select_ranking_series_help": "Valitse rankingsarjat, joihin tämä kilpailusarja kuuluu. Kilpailun tulokset näkyvät valittujen rankingien tulostaulukoissa.",
    "no_point_system": "Ei pistejärjestelmää",
    "configure_point_system_first": "Aseta oletuspistejärjestelmä rankingsarjalle ennen linkittämistä.",
    "configure": "Määritä",
    "navigate_away_title": "Siirry ranking-asetuksiin?",
    "navigate_away_warning": "Sinulla saattaa olla tallentamattomia muutoksia. Haluatko varmasti siirtyä ranking-asetuksiin?",
    "filters": {
      "all_seasons": "Kaikki kaudet",
      "all_tenants": "Kaikki seurat",
      "no_tenant": "Ei seuraa"
    },
    "cards": {
      "basic_info": "Perustiedot",
      "calculation_settings": "Laskenta-asetukset"
    },
    "tabs": {
      "info": "Asetukset",
      "events": "Kilpailut",
      "leaderboard": "Tulostaulukko"
    },
    "fields": {
      "name": "Nimi",
      "name_required": "Nimi on pakollinen",
      "name_placeholder": "esim. 2024 Klubimestaruus",
      "description": "Kuvaus",
      "description_placeholder": "Valinnainen kuvaus",
      "category": "Kategoria",
      "importance_category": "Tärkeyskategoria",
      "season_year": "Kausi",
      "start_date": "Alkamispäivä",
      "start_date_required": "Alkamispäivä on pakollinen",
      "end_date": "Päättymispäivä",
      "calculation_method": "Laskentamenetelmä",
      "calculation_method_points": "Pistetaulukko (sijoitusperusteiset pisteet)",
      "calculation_method_stableford_hcp": "Pistebogey-pisteet (tasoitus, pistebogey-tulosten summa)",
      "calculation_method_stableford_scr": "Pistebogey-pisteet (scratch, pistebogey-tulosten summa)",
      "calculation_help_points": "Pisteet jaetaan sijoitusten mukaan pistejärjestelmän perusteella",
      "calculation_help_stableford": "Lasketaan yhteen kilpailuiden pistebogey-pisteet (tasoitus tai scratch valinnan mukaan)",
      "maximum_events": "Laskettavien tapahtumien enimmäismäärä (valinnainen)",
      "maximum_events_placeholder": "esim. 6",
      "maximum_events_help_optional": "Jätä tyhjäksi, jos lasketaan kaikki tapahtumat. Aseta luku laskemaan vain X parasta tapahtumaa (esim. parhaat 6/10)",
      "tie_handling": "Tasatilanteiden käsittely",
      "tie_handling_tied_best": "Paras tasatilanteessa - Kaikki tasapelaajat saavat parhaan sijoituksen pisteet (antelias)",
      "tie_handling_split": "Jaa pisteet - Pisteet jaetaan keskiarvona tasapelaajien kesken (reilu)",
      "tie_handling_strict": "Tarkka tuloslaskenta - Käytä kilpailun tasatulosratkaisua (kilpailullinen)",
      "tie_handling_help": "Miten pisteet jaetaan tasatilanteessa. Esimerkki: 3 pelaajaa tasatilanteessa sijalla 2 (pisteet: 17, 15, 13). Paras: kaikki saavat 17 p. Jaettu: (17 + 15 + 13) / 3 = kaikille 15 p. Tarkka: kilpailun tasatulosratkaisumalli määrittää 2., 3., 4. → 17 p, 15 p, 13 p",
      "point_system": "Oletuspistejärjestelmä (valinnainen)",
      "point_system_none": "-- Ei oletusta (valitse tapahtumittain) --",
      "point_system_help": "Voidaan muuttaa tapahtumia linkitettäessä",
      "is_public": "Julkinen",
      "tenant": "Seura",
      "tenant_required": "Seura on pakollinen",
      "tenant_placeholder": "-- Valitse seura --",
      "is_public_help": "Kun valittu, pelaajat näkevät tämän rankingin ja sen tulostaulun"
    },
    "table": {
      "name": "Nimi",
      "season": "Kausi",
      "period": "Jakso",
      "method": "Menetelmä",
      "events": "Kilpailut",
      "status": "Tila",
      "tenant": "Seura",
      "actions": "Toiminnot",
      "best_x_of_y": "Parhaat {{max}}/Y",
      "all_events": "Kaikki kilpailut",
      "stableford": "Pistebogey"
    },
    "status": {
      "draft": "LUONNOS",
      "active": "AKTIIVINEN",
      "completed": "VALMIS",
      "archived": "ARKISTOITU"
    },
    "actions": {
      "view_leaderboard": "Näytä tulostaulu",
      "manage_events": "Hallinnoi tapahtumia",
      "back_to_rankings": "Takaisin rankingeihin",
      "edit": "Muokkaa",
      "delete": "Poista",
      "cancel": "Peruuta"
    },
    "leaderboard": {
      "title": "{{name}}",
      "subtitle": "{{year}} Kauden tulostaulu",
      "no_standings": "Ei vielä tuloksia",
      "no_standings_help": "Linkitä ja julkaise sarjoja luodaksesi rankingtuloksia",
      "method": "Menetelmä",
      "method_points_table": "Pistetaulukko",
      "method_stableford": "Pistebogey",
      "method_stableford_hcp": "Pistebogey HCP",
      "method_stableford_scr": "Pistebogey SCR",
      "method_best_x": "Paras {{max}}/{{total}}",
      "method_simple": "Yksinkertainen summa",
      "tie_handling": "Tasatilanteen käsittely",
      "tie_split": "Jaa pisteet",
      "tie_best": "Tasasijoitus",
      "tie_strict": "Tarkka countback",
      "tie_standard": "Standardi",
      "events_published": "Tapahtumat: {{published}} / {{total}} julkaistu",
      "read_more": "Lue lisää",
      "read_less": "Näytä vähemmän",
      "rank": "Sija",
      "player": "Pelaaja",
      "total": "Yhteensä",
      "event": "Tapahtuma",
      "position": "Sijoitus",
      "points": "Pisteet",
      "status": "Tila",
      "actions": "Toiminnot",
      "loading_events": "Ladataan tapahtumia...",
      "no_events_found": "Ei tapahtumia",
      "legend_not_counted": "Ei laskettu yhteispisteisiin",
      "legend_excluded": "Pakotettu poissulku",
      "events_modal_title": "Tapahtumat",
      "events_help": "Vain julkaistujen tapahtumien pisteet näkyvät rankingissa.",
      "failed_to_load": "Tulostaulun lataaminen epäonnistui",
      "failed_to_load_points": "Pelaajan pisteiden lataaminen epäonnistui",
      "not_found": "Rankingsarjaa ei löytynyt",
      "table": {
        "rank": "Sija",
        "player": "Pelaaja",
        "points": "Pisteet",
        "events": "Tapahtumat",
        "counted": "Lasketut",
        "first": "1.",
        "second": "2.",
        "third": "3."
      }
    },
    "events": {
      "title": "Tapahtumat - {{name}}",
      "subtitle": "Linkitä kilpailusarjoja ja julkaise pisteet",
      "no_events": "Ei vielä linkitettyjä tapahtumia",
      "link_first": "Linkitä ensimmäinen sarja",
      "link_series": "Linkitä sarja",
      "failed_to_load": "Tapahtumien lataaminen epäonnistui",
      "failed_to_link": "Sarjan linkitys epäonnistui",
      "publish_title": "Julkaise pisteet",
      "unpublish_title": "Peru julkaisu",
      "failed_to_publish": "Pisteiden julkaisu epäonnistui",
      "failed_to_unpublish": "Julkaisun peruutus epäonnistui",
      "failed_to_delete": "Tapahtuman poisto epäonnistui",
      "linked_success": "Sarja linkitetty rankingiin",
      "published_success": "Pisteet julkaistu",
      "unpublished_success": "Julkaisu peruutettu",
      "deleted_success": "Tapahtuma poistettu rankingista",
      "confirm_publish": "Julkaise pisteet tälle tapahtumalle? Tämä laskee ja jakaa rankingpisteet.",
      "confirm_unpublish": "Peru julkaisu? Tämä poistaa kaikki rankingpisteet tältä tapahtumalta.",
      "confirm_delete": "Poista \"{{name}}\" tästä rankingista?",
      "select_both": "Valitse sekä sarja että pistejärjestelmä",
      "select_series": "Valitse sarja",
      "only_single_weekly": "Vain yksilö- ja viikkokilpailut voidaan linkittää rankingiin",
      "best_x_events": "Parhaat {{max}}/{{total}} tapahtumaa",
      "total_events": "{{total}} tapahtumaa yhteensä",
      "events_published_count": "{{published}} julkaistu",
      "table": {
        "order": "#",
        "series": "Kilpailusarja",
        "point_system": "Pistelaskenta",
        "point_system_stableford_hcp": "Pistebogey (tasoitus)",
        "point_system_stableford_scr": "Pistebogey (scratch)",
        "status": "Tila",
        "published": "Julkaistu",
        "actions": "Toiminnot",
        "status_published": "Julkaistu",
        "status_unpublished": "Ei jaettu",
        "publish": "Julkaise",
        "unpublish": "Peru julkaisu",
        "unpublish_help": "(korjauksia varten)"
      },
      "modal": {
        "title": "Linkitä kilpailusarja",
        "competition_label": "Kilpailu",
        "search_competition": "Hae kilpailua",
        "search_placeholder": "Hae kilpailun nimellä",
        "searching": "Haetaan...",
        "no_results": "Ei tuloksia",
        "competition_select": "-- Valitse kilpailu --",
        "series_label": "Sarja",
        "series_select": "-- Valitse sarja --",
        "no_series_available": "Ei sarjoja saatavilla",
        "select_competition_first": "Valitse ensin kilpailu",
        "point_system": "Pistejärjestelmä",
        "point_system_select": "-- Valitse pistejärjestelmä --",
        "point_system_help": "Sijoituksista jaettavat pisteet",
        "cancel": "Peruuta",
        "link": "Linkitä sarja"
      }
    },
    "importance_category": {
      "major": "Major-kilpailu",
      "standard": "Normaali kilpailu",
      "minor": "Pieni kilpailu",
      "custom": "Mukautettu"
    },
    "point_systems": {
      "page_title": "Pistejärjestelmät",
      "title": "Pistejärjestelmät",
      "create_new": "Luo uusi",
      "create_first": "Luo ensimmäinen pistejärjestelmä",
      "edit_system": "Muokkaa pistejärjestelmää",
      "no_systems": "Ei vielä pistejärjestelmiä",
      "point_allocations": "Pistejakaumat",
      "positions": "sijaa",
      "points_required": "Pisteet ovat pakollisia",
      "points_help": "Anna pisteet pilkulla erotettuna, korkeimmasta matalimpaan (esim. 50, 40, 35, 30...)",
      "system_default": "Oletusjärjestelmä",
      "custom": "Mukautettu",
      "type": "Tyyppi",
      "created_success": "Pistejärjestelmä luotu",
      "updated_success": "Pistejärjestelmä päivitetty",
      "deleted_success": "Pistejärjestelmä poistettu",
      "failed_to_save": "Pistejärjestelmän tallennus epäonnistui",
      "failed_to_delete": "Pistejärjestelmän poisto epäonnistui",
      "confirm_delete": "Haluatko varmasti poistaa \"{{name}}\"?",
      "delete_title": "Poista pistejärjestelmä",
      "create_for": "Luo kohteelle",
      "system_default_option": "Järjestelmän oletus (kaikki seurat)",
      "tenant_label": "Seura",
      "cannot_delete_in_use_series": "Pistejärjestelmää ei voi poistaa, koska se on käytössä {{count}} rankingsarjassa",
      "cannot_delete_in_use_events": "Pistejärjestelmää ei voi poistaa, koska se on käytössä {{count}} rankings-tapahtumassa",
      "cannot_delete_in_use_both": "Pistejärjestelmää ei voi poistaa, koska se on käytössä {{seriesCount}} rankingsarjassa ja {{eventsCount}} rankings-tapahtumassa"
    },
    "exclusion": {
      "exclude_result": "Sulje pois tulos",
      "include_result": "Sisällytä tulos",
      "exclusion_reason": "Poissulkemisen syy",
      "excluded_success": "Tulos poistettu rankingista",
      "included_success": "Tulos sisällytetty rankingiin",
      "failed_to_update": "Poissulkemisen päivittäminen epäonnistui",
      "status": {
        "excluded": "Poissuljetttu",
        "not_counted": "Ei lasketa",
        "counted": "Lasketaan"
      }
    }
  },
  "favorites": {
    "add": "Lisää suosikkeihin",
    "remove": "Poista suosikeista"
  },
  "weather": {
    "banner": {
      "warning_title": "Säävaroitus",
      "delayed_title": "Peli keskeytetty",
      "eta": "Arvioitu jatkoaika {{time}}",
      "no_eta": "Peliä jatketaan myöhemmin ilmoitettavana ajankohtana"
    },
    "button": {
      "none_tooltip": "Säävaroitus (ei varoituksia)",
      "warning_tooltip": "Säävaroitus aktiivinen",
      "delayed_tooltip": "Peli keskeytetty",
      "aria_none": "Säävaroitus",
      "aria_warning": "Säävaroitus aktiivinen",
      "aria_delayed": "Peli keskeytetty"
    },
    "modal": {
      "title": "Säävaroitus",
      "stage_label": "Tila",
      "stage_none": "Ei varoitusta",
      "stage_warning": "Säävaroitus",
      "stage_delayed": "Peli keskeytetty",
      "reason_label": "Syy",
      "reason_placeholder": "Esim. Ukkosmyrsky lähestyy",
      "eta_label": "Arvioitu jatkumisaika (valinnainen)",
      "eta_hint": "Jätä tyhjäksi, jos jatkumisaika ei ole tiedossa",
      "reason_required": "Syy on pakollinen, kun säävaroitus on voimassa",
      "save_button": "Tallenna",
      "cancel_button": "Peruuta"
    }
  }
}
